import React from 'react';
import { Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { Button } from './carousel-buttons.style';

const getCopy = copyFor('carouselButtons');

interface Props {
  index: number;
  setIndex: (index: number) => void;
  itemName: string;
  length: number;
  margin?: Margin;
  justifyContent?: 'center' | 'flex-start' | 'flex-end';
}

// TODO refactor notifications carousel to use this component
export const CarouselButtons = ({
  index,
  setIndex,
  itemName,
  length,
  margin,
  justifyContent,
}: Props) => {
  return (
    <Container
      flex
      alignItems="center"
      width="100%"
      justifyContent={justifyContent || 'center'}
      margin={margin || { top: '16px', bottom: '16px' }}
    >
      <Button
        icon="ChevronLeft"
        aria-label={getCopy('previous', { itemName })}
        disabled={index === 0}
        onClick={() => setIndex(index - 1)}
      />
      <Text>{getCopy('inner', { index: index + 1, length })}</Text>
      <Button
        icon="ChevronRight"
        aria-label={getCopy('next', { itemName })}
        disabled={index === length - 1}
        onClick={() => setIndex(index + 1)}
      />
    </Container>
  );
};
